import React, { useState } from "react";
import api from "../../api/axios";

const EmailModal = ({ email, onClose }) => {
  const [form, setForm] = useState({
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const sendEmail = async () => {
    if (!form.subject || !form.message) {
      alert("Subject and message are required");
      return;
    }

    setLoading(true);

    try {
      await api.post("companyblog/admin/contact-info/email/", {
        to: email,
        subject: form.subject,
        message: form.message,
      });

      alert("Email sent successfully");
      onClose();
    } catch (err) {
      alert("Failed to send email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ---------- INLINE CSS ---------- */}
      <style>{`
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }

        .modal-box {
          background: #fff;
          width: 600px;
          border-radius: 8px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.25);
          padding: 20px;
        }

        .modal-box h4 {
          margin-bottom: 15px;
          font-weight: 600;
          border-bottom: 1px solid #eee;
          padding-bottom: 10px;
        }

        .modal-box input,
        .modal-box textarea {
          width: 100%;
          padding: 10px;
          margin-bottom: 12px;
          border: 1px solid #ccc;
          border-radius: 4px;
          font-size: 14px;
        }

        .modal-box input:disabled {
          background: #f5f5f5;
          color: #555;
        }

        .modal-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          margin-top: 10px;
        }

        .btn-success {
          background-color: #198754;
          border: none;
          padding: 8px 16px;
          color: #fff;
          border-radius: 4px;
        }

        .btn-secondary {
          background-color: #6c757d;
          border: none;
          padding: 8px 16px;
          color: #fff;
          border-radius: 4px;
        }

        .btn-success:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
      `}</style>

      {/* ---------- MODAL UI ---------- */}
      <div className="modal-overlay">
        <div className="modal-box">
          <h4>Compose Email</h4>

          <input value="admin@yourdomain.com" disabled />
          <input value={email} disabled />

          <input
            placeholder="Subject"
            value={form.subject}
            onChange={(e) =>
              setForm({ ...form, subject: e.target.value })
            }
          />

          <textarea
            rows="6"
            placeholder="Message"
            value={form.message}
            onChange={(e) =>
              setForm({ ...form, message: e.target.value })
            }
          />

          <div className="modal-actions">
            <button
              className="btn-success"
              onClick={sendEmail}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send"}
            </button>

            <button className="btn-secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailModal;
